<template>
  <div class="fit-content">
    <div>
      <DataTableDeCrud
        :items="perfis"
        :headers="headers"
        :rotina-id="ID_TELA_DE_PERFIS"
        :loading="loading"
        @create="() => abrirDialogCriarPerfil()"
        @update="(indice) => abrirDialogEditarPerfil(indice)"
        @configure="(indice) => abrirDialogConfigurarPerfil(indice)"
        @delete="(indice) => abrirDialogExcluirPerfil(indice)"
      />
      <DialogDeEdicaoDePerfil
        :operacao="operacao"
        :show-dialog.sync="showDialogParam"
        :perfil="perfilParam"
        :itens="itensPermissao"
        @confirmado="atualizarPerfil"
      />
      <SnackbarMessage
        :show-snack.sync="snackbar.showSnackParam"
        :snack-text="snackbar.snackTextParam"
        :snack-type="snackbar.snackTypeParam"
      />

      <v-dialog v-model="dialogExcluirPerfil" persistent max-width="380">
        <v-card>
          <v-card-title class="headline">Excluir</v-card-title>
          <v-card-text refs="itemPerfilExclusao">
            Tem certeza que deseja excluir o perfil <b> {{ itemPerfilExclusao.nome }} </b>?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="dialogExcluirPerfil = false">Cancelar</v-btn>
            <v-btn color="green darken-1" text @click="excluirPerfil">Confirmar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <DialogDeConfiguracaoDePermissaoPerfil
      :show-dialog-settings.sync="showDialogSettingsParam"
      :perfil="perfilSettingsParam"
    />
  </div>
</template>

<script>
import PerfilService from '@/services/usuario/perfil'
import PermissaoService from '@/services/usuario/permissao'
import SnackbarMessage from '@/components/SnackbarMessage'
import DialogDeEdicaoDePerfil from '@/components/perfis/DialogDeEdicaoDePerfil'
import DataTableDeCrud from '@/components/DataTableDeCrud'
import SnackBar from '@/models/components/snackbar'
import Perfil from '@/models/perfil'
import DialogDeConfiguracaoDePermissaoPerfil from '@/components/perfis/DialogDeConfiguracaoDePermissaoPerfil.vue'
import { ID_TELA_DE_PERFIS } from '@/common/constants'

export default {
  components: {
    SnackbarMessage,
    DataTableDeCrud,
    DialogDeEdicaoDePerfil,
    DialogDeConfiguracaoDePermissaoPerfil
  },
  data: () => ({
    name: 'TelaDePerfis',
    headers: [{ text: 'Nome', value: 'nome' }],
    perfis: [],
    loading: false,
    validForm: false,
    dialog: false,
    operacao: '',
    showDialogParam: false,
    showDialogSettingsParam: false,
    perfilParam: new Perfil(),
    perfilSettingsParam: new Perfil(),
    itensPermissao: {},
    snackbar: new SnackBar(),
    dialogExcluirPerfil: false,
    itemPerfilExclusao: new Perfil(),
    indicePerfilExclusao: 0,
    ID_TELA_DE_PERFIS: ID_TELA_DE_PERFIS
  }),

  created() {
    this.initialize()
  },

  methods: {
    initialize() {
      try {
        this.loadPerfis()
        this.loadPermissoes()
      } catch (error) {
        this.snackbar.snackTextParam = 'Não foi possível encontrar perfis cadastrados.'
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      }
    },

    async loadPerfis() {
      this.loading = true
      const response = await PerfilService.getAll()
      this.perfis = response.map((item) => ({
        ...item
      }))
      this.loading = false
    },

    async loadPermissoes() {
      const response = await PermissaoService.getAll()
      this.itensPermissao = response.map((item) => ({
        text: item.nome,
        value: item.id
      }))
    },

    atualizarPerfil(perfil) {
      if (!perfil) return

      const indice = this.perfis.findIndex((perfilExistente) => perfilExistente.id === perfil.id)

      if (indice === -1) {
        this.perfis.push(perfil)
        this.snackbar.snackTextParam = 'Perfil criado com sucesso.'
      } else {
        this.perfis.splice(indice, 1, perfil)
        this.snackbar.snackTextParam = 'Perfil atualizado com sucesso.'
      }

      this.snackbar.snackTypeParam = 'sucess'
      this.snackbar.showSnackParam = true
    },

    abrirDialogExcluirPerfil(indice) {
      this.itemPerfilExclusao = this.perfis[indice]
      if (!this.itemPerfilExclusao.id) return

      this.indicePerfilExclusao = indice
      this.dialogExcluirPerfil = true
    },

    async excluirPerfil() {
      try {
        await PerfilService.deleteById(this.itemPerfilExclusao.id)
        this.snackbar.snackTextParam = 'Perfil removido com sucesso.'
        this.snackbar.snackTypeParam = 'sucess'
        this.snackbar.showSnackParam = true
        this.perfis.splice(this.indicePerfilExclusao, 1)
      } catch (error) {
        this.snackbar.snackTextParam = `${error.response.status} | ${
          error.response.data.message === undefined ? error.message : error.response.data.message
        }`
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      }
      this.dialogExcluirPerfil = false
    },

    abrirDialogCriarPerfil() {
      this.operacao = 'adicionar'
      this.perfilParam = new Perfil()
      this.showDialogParam = true
    },

    abrirDialogEditarPerfil(indice) {
      this.operacao = 'editar'
      this.perfilParam = { ...this.perfis[indice] }
      this.showDialogParam = true
    },

    abrirDialogConfigurarPerfil(indice) {
      this.perfilSettingsParam = { ...this.perfis[indice] }
      this.showDialogSettingsParam = true
    }
  }
}
</script>
